"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Piechart = _interopRequireDefault(require("./Piechart"));
var _piedata = _interopRequireDefault(require("./piedata.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultgraphData = {
  labels: [],
  datasets: [{
    backgroundColor: [],
    data: []
  }]
};
function App(_ref) {
  let {
    dataFromTextArea,
    json,
    graphstyle,
    backdropstyle
  } = _ref;
  const jsonDataa = JSON.stringify(_piedata.default);
  const [inputText, setInputText] = (0, _react.useState)(defaultgraphData);
  const jsonProp = JSON.stringify(json);
  let pointstyleUse = false;
  (0, _react.useEffect)(() => {
    if (JSON.stringify(json) == "" && _piedata.default) {
      if (dataFromTextArea && isJsonString(dataFromTextArea)) {
        let dataObj = handleJsonData(JSON.parse(dataFromTextArea));
        console.log("DataObject ", dataObj);
        let labeldata = handleLabel(labelJSON);
        const graphData = {
          labels: labeldata.labels,
          datasets: [{
            label: dataObj.technology,
            backgroundColor: dataObj.backgroundColor1,
            data: dataObj.data1
          }]
        };
        setInputText(graphData);
      } else if (isJsonString(jsonDataa)) {
        let dataObj = handleJsonData(JSON.parse(jsonDataa));
        let dataArray = [];
        dataArray = [].concat(...dataObj.data1);
        console.log("DataArray : ", dataArray);
        console.log("DataObject ", dataObj);
        let labeldata = handleLabel(labelJSON);
        const graphData = {
          labels: labeldata.labels,
          datasets: [{
            label: dataObj.technology,
            backgroundColor: dataObj.backgroundColor1,
            data: dataArray
          }]
        };
        setInputText(graphData);
      }
    } else {
      let dataObj = handleJsonData(JSON.parse(jsonProp));
      const graphData = {
        labels: dataObj.category,
        datasets: [{
          label: dataObj.technology,
          backgroundColor: dataObj.backgroundColor1,
          data: dataObj.data1
        }]
      };
      setInputText(graphData);
    }
  }, [dataFromTextArea, json, jsonDataa]);
  const options = {
    responsive: true,
    borderWidth: 0.4,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: graphstyle.labelposition == undefined || graphstyle.labelposition == "" || graphstyle.labelposition == null ? "bottom" : graphstyle.labelposition.toLowerCase(),
        labels: {
          usePointStyle: graphstyle.pointstyle == undefined || graphstyle.pointstyle == "" || graphstyle.pointstyle == null ? pointstyleUse = false : pointstyleUse = true,
          pointStyle: graphstyle.pointstyle == undefined || graphstyle.pointstyle == "" || graphstyle.pointstyle == null ? "circle" : graphstyle.pointstyle,
          font: {
            size: graphstyle.size == undefined || graphstyle.size == null || graphstyle.size == "" ? 6 : graphstyle.size
            // size:10
          }
        }
      },

      tooltip: {
        enabled: true
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mac-valign"
  }, /*#__PURE__*/_react.default.createElement(_Piechart.default, {
    data: inputText,
    options: options,
    style: graphstyle,
    backstyle: backdropstyle
  }));
}
var _default = exports.default = App;
function handleJsonData(chartData) {
  let category = chartData.map(item => item.technology == null || item.technology == "" ? item.category : item.category + "-" + item.technology);
  let technology = chartData.map(item => item.technology);
  let data1 = chartData.map(item => item.value);
  let backgroundColor1 = chartData.map(item => item.color);
  return {
    category,
    technology,
    data1,
    backgroundColor1
  };
}
function handleLabel(label) {
  let labels = label.map(item => item);
  return {
    labels
  };
}
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}